/**
 * Die Einstellungsseite in der Sprache der Oberflaeche.
 *
 * roboter-einstellungen.ts bleibt die Quelle: dort stehen Aufrufe, Zeitpunkte
 * und die Anbindung an die Firmware. Eine Uebersetzung liefert nur die Texte,
 * in derselben Reihenfolge. Aufrufe und Zahlenangaben werden nicht doppelt
 * gepflegt und koennen deshalb nicht auseinanderlaufen.
 */

import en from "./roboter-einstellungen.en";
import vi from "./roboter-einstellungen.vi";
import {
  Einstellung,
  FesterWert,
  GRUNDSAETZE,
  GRUPPEN,
  Gruppe,
  Zeitpunkt,
  ZEITPUNKT_TEXT,
} from "./roboter-einstellungen";

export type TextEinstellung = Pick<
  Einstellung,
  "name" | "vorgabe" | "bereich" | "wirkung" | "hinweis"
>;

export type TextFesterWert = Pick<FesterWert, "name" | "wert" | "bedeutung">;

export interface TextGruppe {
  titel: string;
  einleitung: string;
  einstellungen: TextEinstellung[];
  fest?: TextFesterWert[];
}

export interface Texte {
  zeitpunkt: Record<Zeitpunkt, string>;
  grundsaetze: string[];
  /** Je Gruppe, ueber ihre ``id``. */
  gruppen: Record<string, TextGruppe>;
}

export interface Einstellungsseite {
  zeitpunkt: Record<Zeitpunkt, string>;
  grundsaetze: string[];
  gruppen: Gruppe[];
}

export const UEBERSETZUNGEN: Record<string, Texte> = { en, vi };

const deutsch: Einstellungsseite = {
  zeitpunkt: ZEITPUNKT_TEXT,
  grundsaetze: GRUNDSAETZE,
  gruppen: GRUPPEN,
};

function uebersetzt(texte: Texte): Einstellungsseite {
  return {
    zeitpunkt: texte.zeitpunkt,
    grundsaetze: texte.grundsaetze,
    gruppen: GRUPPEN.map((gruppe) => {
      const text = texte.gruppen[gruppe.id];
      return {
        ...gruppe,
        titel: text.titel,
        einleitung: text.einleitung,
        einstellungen: gruppe.einstellungen.map((einstellung, index) => ({
          ...einstellung,
          ...text.einstellungen[index],
        })),
        fest: gruppe.fest?.map((wert, index) => ({
          ...wert,
          ...text.fest![index],
        })),
      };
    }),
  };
}

/**
 * Seite fuer eine Sprachkennung wie "de", "en" oder "vi".
 *
 * Deutsch ist die Quelle; jede Sprache ohne eigene Uebersetzung bekommt die
 * englische, wie die uebrige Oberflaeche.
 */
export function einstellungsseite(sprache: string): Einstellungsseite {
  const kurz = sprache.toLowerCase().split("-")[0];
  if (kurz === "de") {
    return deutsch;
  }
  return uebersetzt(UEBERSETZUNGEN[kurz] ?? en);
}
